import { useEffect, useState } from 'react';
import { CrmLinksContextProvider, useCrmLinksContext } from './internal/CrmLinksContext';
import { FetchStatuses } from '../types/FetchStatus';
import UserInfoPromise from 'hub-http/userInfo';
import { UserInfoContext } from './internal/UserInfoContext';
import Raven from 'raven-js';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const CrmLinksDataProvider = ({
  children
}) => {
  const [userInfo, setUserInfo] = useState(undefined);
  const parentContextState = useCrmLinksContext();
  useEffect(() => {
    UserInfoPromise().then(info => {
      setUserInfo(info);
    }).catch(error => {
      Raven.captureException(error);
    });
  }, []);

  /**
   * Avoids refetching and repackaging FAS/GQL data if a
   * CrmLinksDataProvider already exists in the parent.
   */
  if (parentContextState.status !== FetchStatuses.IDLE) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/_jsx(UserInfoContext.Provider, {
    value: userInfo,
    children: /*#__PURE__*/_jsx(CrmLinksContextProvider, {
      children: children
    })
  });
};